import { TableFiltersState } from '../../../../utils/table-filters/filter-table-types';

import { initialFilters } from '../../../../utils/table-filters/const';
import { PERIODS } from '../components/period-dropdown';

export const initialFilterTableState: TableFiltersState = {
  filterAnchorElement: null,
  filters: { ...initialFilters }
};

export enum CUSTOMER_SUPPLIER_KIND {
  CUSTOMER = 'customer',
  SUPPLIER = 'supplier'
}

export const customersAndSuppliersPeriodMap: Record<PERIODS, string> = {
  [PERIODS.THIS_MONTH]: 'this-month',
  [PERIODS.LAST_MONTH]: 'last-month',
  [PERIODS.LAST_YEAR]: 'last-year',
  [PERIODS.THIS_QUARTER]: 'this-quarter',
  [PERIODS.THIS_YEAR]: 'this-year',
  [PERIODS.LAST_QUARTER]: 'last-quarter',
  [PERIODS.LAST_3_MONTHS]: 'last-3-months',
  [PERIODS.LAST_6_MONTHS]: 'last-6-months',
  [PERIODS.LAST_12_MONTHS]: 'last-12-months',
  [PERIODS.LAST_24_MONTHS]: 'last-24-months'
};
